module.exports = __webpack_public_path__ + "img/bobcat-logo.14c18939.jpg";